module.exports = __webpack_public_path__ + "img/chat-quan-an.3b424fa4.png";